// extracted by mini-css-extract-plugin
export var leftAlign = "_2j-2";
export var popper = "_2j-0";
export var subtitle = "_2j-1";